module.exports = __webpack_public_path__ + "img/L_JH.8493fafd.png";